// extracted by mini-css-extract-plugin
export var cartIcon = "_oi-0";
export var cartIconContainer = "_oi-1";